<ng-template #loadingBlock>
    <mat-spinner></mat-spinner>
</ng-template>
<mat-toolbar class="filters" *ngIf="isReady else loadingBlock">
    <mat-toolbar-row>
        <mat-form-field *ngIf="isDisplayed('startDate')">
            <!--suppress HtmlFormInputWithoutLabel -->
            <input name="startDate"
                   [formControl]="controls.startDate"
                   matInput
                   [matDatepicker]="startPicker"
                   placeholder="{{'generic.beginning_date' | translate}}"
            />
            <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field *ngIf="isDisplayed('endDate')">
            <!--suppress HtmlFormInputWithoutLabel -->
            <input name="endDate"
                   [formControl]="controls.endDate"
                   matInput
                   [matDatepicker]="endPicker"
                   placeholder="{{'generic.deadline' | translate}}"
            />
            <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field *ngIf="isDisplayed('view')">
            <mat-select [formControl]="controls.view" placeholder="{{ 'graph.views' | translate }}">
                <mat-option value="simple">{{ 'graph.views_simple' | translate }}</mat-option>
                <mat-option value="complex">{{ 'graph.views_complex' | translate }}</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field *ngIf="isDisplayed('attendanceView')">
            <mat-select [formControl]="controls.attendanceView" placeholder="{{ 'graph.views' | translate }}">
                <mat-option value="global">{{ 'graph.attendance_views_global' | translate }}</mat-option>
                <mat-option value="activity">{{ 'graph.attendance_views_activity' | translate }}</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field *ngIf="isDisplayed('exerciseType')">
            <mat-select [formControl]="controls.exerciseType" placeholder="{{ 'graph.progression_exercise_type' | translate }}">
                <mat-option *ngIf="isEmptyAllowed('exerciseType')" [value]="">{{ 'graph.progression_none' | translate }}</mat-option>
                <mat-option *ngFor="let exerciseType of exerciseTypes" [value]="exerciseType.get('name')">{{ exerciseType.get('name') }}</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field *ngIf="isDisplayed('multiLesson')">
            <mat-select [formControl]="controls.multiLesson" placeholder="{{ 'graph.progression_select_lessons' | translate }}" multiple>
                <mat-option *ngFor="let lesson of lessons" [value]="lesson.get('metadatas')?.title">{{lesson.get('metadatas')?.title}}</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field *ngIf="isDisplayed('errors')">
            <mat-select [formControl]="controls.errors" placeholder="{{ 'graph.progression_select_errors' | translate }}" multiple>
                <mat-option *ngFor="let error of errors" [value]="error">{{error}}</mat-option>
            </mat-select>
        </mat-form-field>
    </mat-toolbar-row>
    <mat-toolbar-row>
        <mat-form-field *ngIf="isDisplayed('group')">
            <mat-select [formControl]="controls.group"  placeholder="{{ 'graph.select_groups' | translate }}">
                <mat-option></mat-option>
                <mat-option *ngFor="let group of groups" [value]="group.groupname">{{ group.groupname }}</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field *ngIf="isDisplayed('workgroup')">
            <mat-select [formControl]="controls.workgroup" placeholder="{{ 'graph.select_workgroups' | translate }}">
                <mat-option></mat-option>
                <mat-option *ngFor="let workgroup of workgroups"
                            [value]="workgroup.workgroupname">{{ workgroup.workgroupname }}</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field *ngIf="isDisplayed('learner')">
            <label>
                <input type="text"
                       [placeholder]="'graph.learner' | translate"
                       matInput
                       [formControl]="controls.learner"
                       [matAutocomplete]="autoLearner">
            </label>
            <mat-autocomplete #autoLearner="matAutocomplete">
                <mat-option appAriaTitle *ngFor="let learnerNickname of filteredLearners | async" [value]="learnerNickname">
                    {{learnerNickname}}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
        <mat-form-field *ngIf="isDisplayed('multiLearner')">
            <mat-select [formControl]="controls.multiLearner" placeholder="{{ 'graph.select_learners' | translate }}" multiple>
                <mat-option *ngFor="let learnerNickname of filteredByGroupLearners | async" [value]="learnerNickname">{{learnerNickname}}</mat-option>
            </mat-select>
        </mat-form-field>
        <button *ngIf="couldExpend()" (click)="toggle()" class="btn-collapse">
            <span>{{ (barIsExpended ? 'filters.button.collapse' : 'filters.button.expand') | translate }}</span>
            <mat-icon class="collapsable-arrow" [svgIcon]="barIsExpended ? 'keyboard_arrow_down' : 'keyboard_arrow_up'"></mat-icon>
        </button>
    </mat-toolbar-row>
</mat-toolbar>
